import {ad_click} from "@u/AnalysysAgent";

class Utils {
  constructor() {
    this.from = new URLSearchParams(window.location.search).get('from');
    this.userAgent = navigator.userAgent;
    this.isAndroid = !!this.userAgent.match(/android/ig);
    this.isIos = !!this.userAgent.match(/iphone|ipod/ig);
    this.isIpad = !!this.userAgent.match(/ipad/ig);
    this.isWeixin = (/MicroMessenger/ig).test(this.userAgent);
    this.isQQ = (/qq/ig).test(this.userAgent);
    this.platform = this.which_platform();
  }

  which_platform() {
    if (this.from == 'app') {
      return 'app';
    } else if (this.from == 'app_ios') {
      return 'app_ios';
    } else if (this.isWeixin) {
      return 'weixin';
    } else if (this.isQQ) {
      return 'QQ';
    } else if (this.isIos) {
      return 'isIos';
    } else if (this.isIpad) {
      return 'isIpad';
    } else {
      return 'unclear';
    }
  }

  execute(){
    ad_click(this.data)
    if (this.app_type && this.platform == 'app') {
      this.android();
    } else if (this.app_type && this.platform == 'app_ios') {
      this.ios(this.app_data, this.app_data2)
    } else {
      window.open(this.web_href, '_blank');
    }
  }

  android(){
    window.swshare[this.app_type](this.app_data,this.app_data2);
  }

  ios(argument1,argument2){
    let data;
    if(this.app_type === 'toInfo'){
      this.app_type = 'toInfo_s'
      // toInfo加_s的不要域名
      argument1 = argument1.replace(window.location.origin, '')
      if(argument2){
        argument2 = argument2.replace(window.location.origin, '')
      }
    }
    if(argument2){
      data = [argument1,argument2];
    }else{
      data = argument1;
    }
    window.webkit.messageHandlers[this.app_type].postMessage(data);
  }
}

export class NyhAd extends Utils {
  data = null; // 广告数据
  app_type = ''; // 广告类型
  app_data = ''; // 广告 参数1
  app_data2 = ''; // 广告 参数2
  web_href = ''; // h5路径
  constructor(data) {
    super();
    this.appInteraction(data)
  }

  /*-------------------------------------------------*/
  appInteraction(data) {
    if(!data.module) return;
    this.data = data;
    switch (data.module) {
      case 'meeting':
        // 会议
        this.app_type = 'toMeetingLive';
        this.app_data = data.extras;
        this.web_href = `/meetingInfoLive.jspx?id=${data.extras}`;
        break;
      case 'meetingFields':
        // 会场
        this.app_type = 'toMeetingByFields';
        this.app_data = data.extras;
        this.web_href = `/meetingInfoLive.jspx?fieldsId=${data.extras}`;
        break;
      case 'meetingAgenda':
        // 日程
        this.app_type = 'toMeetingHomeDetailByAgendaId';
        this.app_data = data.extras;
        this.web_href = `/meetingInfoLive.jspx?agendaId=${data.extras}`;
        break;
      case 'agenda':
        this.app_type = 'toMeetingHomeDetailByAgendaId';
        this.app_data = data.id;
        this.web_href = `/meetingInfoLive.jspx?agendaId=${data.id}`;
        break
      case 'info':
      case 'other':
        // 文章
        this.app_type = 'toInfo';
        this.app_data = data.extras;
        this.web_href = data.extras;
        break;
      case 'ocscourse':
        // 云课堂
        this.app_type = 'toCloudClass';
        this.app_data = data.extras;
        this.web_href = `/ocscourse/#/pages/coursePlay/coursePlay?courseId=${data.extras}`;
        break;
      case 'mparticle':
        // mp文章
        this.app_type = 'toInfo';
        this.app_data = data.extras;
        this.web_href = `/mp/${data.extras}.jspx`;
        break;
      case 'shortVideo':
        // 短视频
        this.app_type = 'toCompetition';
        this.app_data = data.extras;
        this.web_href = `/app/shortplayer/index.html?id=${data.extras}`;
        break;
      case 'shortVideoCompetition':
        // 短视频比赛
        this.web_href = `/shortvideo/competition?competitionId=${data.extras}`;
        break;
      case 'brand':
        // 品牌
        this.app_type = 'toApparatusDetailByIdOrProductLineId';
        this.app_data = data.extras
        this.app_data2 = 'BrandId'
        this.web_href = `/bms/productionline/${data.extras}`
        break;
      case 'brandProductLine':
        // 产线
        this.app_type = 'toApparatusDetailByIdOrProductLineId';
        this.app_data = data.extras
        this.app_data2 = 'productLineId'
        this.web_href = `/bms/brandDetails/null/${data.extras}`
        break;
      case 'brandActivity':
        // 品牌活动
        this.app_type = 'toInfo'
        this.app_data = data.extras
        this.web_href = `/bms/brandZone/${data.extras}`;
        break;
      case 'product':
        // 产品
        this.app_type = 'toProductDetail';
        this.app_data = data.extras;
        this.web_href = `/bms/instrument/${data.extras}`;
        break;
      case 'elab_case':
        // elab模块
        this.app_type = 'goElabHome';
        this.app_data = data.extras;
        this.web_href = `/elabweb/`;
        break;
      case 'elab_case_detail':
        // elab模块
        this.app_type = 'goElabVideoPlay';
        this.app_data = data.extras;
        this.web_href = `/app/elab/video.html?id=${data.extras}`;
        break;
      case 'elab_special_column':
        // elab专栏
        this.web_href = `/elabweb/columnInfo/${data.extras}`
        break;
      case 'weekly':
        // 周刊
        this.app_type = 'openWeeklyDetail';
        this.app_data = data.extras
        this.web_href = `/app/weekly/index.html?weeklyId=${data.extras}`
        break;
      case 'community_home':
        // 话题首页
        this.web_href = `/topic-circle/`
        break;
      case 'community_question':
        // 问题
        this.app_type = 'openTheQuestion';
        this.app_data = data.extras;
        this.web_href = `/topic-circle/questionhome?id=${data.extras}`
        break;
      case 'community_answer':
        // 回答
        this.app_type = 'communityAnswer';
        this.app_data = data.extras;
        this.web_href = data.extras;
        break;
      case 'community_qa':
        // 话题
        this.app_type = 'openTheTopic'
        this.app_data = data.extras;
        this.web_href = `/topic-circle/topicdetail?id=${data.extras}`;
        break;
      case 'community_circle':
        // 圈子
        this.app_type = 'openTheCircle'
        this.app_data = data.extras;
        this.web_href = `/topic-circle/spheresdetail?id=${data.extras}`;
        break;
      case 'community_activity':
        // 活动
        // this.app_type = 'openTheCircle'
        // this.app_data = data.extras;
        this.web_href = `/topic-circle/activitydetail?id=${data.extras}`;
        break
      case 'article_column':
        // 文章专栏
        // this.app_type = 'openTheCircle'
        // this.app_data = data.extras;
        this.web_href = `/special/detail.jspx?id=${data.extras}`;
        break;
    }
  }
}
